module.exports = __webpack_public_path__ + "static/media/peterArt1.34ea8071.jpg";